module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAAAXNSR0IArs4c6QAAARtJREFUKFOVklFKw0AQhmc2trLpe8EDiI9uDRUsaEoFPUEPoGAVPY+iFfQAPYEPxkahgpI2vikeQPC9WWzN/rItasUKZp52/t1vhn9mOVF+QKAVYmfdjYMOTYlE1SqE9JIIHUZlo6j7bxEYjutIj6OLl0kG3uZckuqIwakszHpsL/vKLzPohpi6cr5Y5VZrYHXU63n9/Nom0BKYVgtxeD8CbOhFf8sQzoSgE9m73htppbVjY2hXEG/Lh/Dcal+ATRLlHwLYF8wNmxugycxHbhwefBb+AcBr5PT7U0CE5fEDvpMzCzWOmsOpgBUHqqqGMD17zrEo5eN2PDmE3x3SxysClf/V4duD2Bl7MKd/esg0pUx7yLzpTH+J6fYDJEOse3C7k8kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/learnmodel/cuo@2x.png
// module id = 3oM7
// module chunks = 96